export enum WeekdaySegments {
  sunday = 'AnalyticsEvent.sunday',
  monday = 'AnalyticsEvent.monday',
  tuesday = 'AnalyticsEvent.tuesday',
  wednesday = 'AnalyticsEvent.wednesday',
  thursday = 'AnalyticsEvent.thursday',
  friday = 'AnalyticsEvent.friday',
  saturday = 'AnalyticsEvent.saturday',
}

export enum TeamAnalyticsActivityV2WeekdaySegments {
  sunday = 'TeamAnalyticsActivityV2.sunday',
  monday = 'TeamAnalyticsActivityV2.monday',
  tuesday = 'TeamAnalyticsActivityV2.tuesday',
  wednesday = 'TeamAnalyticsActivityV2.wednesday',
  thursday = 'TeamAnalyticsActivityV2.thursday',
  friday = 'TeamAnalyticsActivityV2.friday',
  saturday = 'TeamAnalyticsActivityV2.saturday',
}

export enum OrganizationAnalyticsEventWeekdaySegments {
  sunday = 'OrgAnalyticsEvent.sunday',
  monday = 'OrgAnalyticsEvent.monday',
  tuesday = 'OrgAnalyticsEvent.tuesday',
  wednesday = 'OrgAnalyticsEvent.wednesday',
  thursday = 'OrgAnalyticsEvent.thursday',
  friday = 'OrgAnalyticsEvent.friday',
  saturday = 'OrgAnalyticsEvent.saturday',
}

export enum AnalyticsActivityWeekdaySegments {
  sunday = 'AnalyticsActivityV2.sunday',
  monday = 'AnalyticsActivityV2.monday',
  tuesday = 'AnalyticsActivityV2.tuesday',
  wednesday = 'AnalyticsActivityV2.wednesday',
  thursday = 'AnalyticsActivityV2.thursday',
  friday = 'AnalyticsActivityV2.friday',
  saturday = 'AnalyticsActivityV2.saturday',
}

export enum TeamAnalyticsEventWeekdaySegments {
  sunday = 'OrgAnalyticsEvent.sunday',
  monday = 'OrgAnalyticsEvent.monday',
  tuesday = 'OrgAnalyticsEvent.tuesday',
  wednesday = 'OrgAnalyticsEvent.wednesday',
  thursday = 'OrgAnalyticsEvent.thursday',
  friday = 'OrgAnalyticsEvent.friday',
  saturday = 'OrgAnalyticsEvent.saturday',
}